export default {
    app_name: 'Bookeraj',

    microcopy: {
        add: 'Добавить',
        add_plus: '+ Добавить',
        back: 'Назад',
        ok: 'Ок',
        remove: 'Удалить',
        next: 'Далее',
        complete: 'Завершить',
        close: 'Закрыть',
        continue: 'Продолжить',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        new: 'Новый',
        save: 'Сохранить',
        created: 'Создано',
        success: 'Успех',
        none: 'Нет',
        category: 'Категория',
        delete: 'Удалить',
        edit: 'Редактировать',
        accept: 'Принять',
        decline: 'Отклонить',
        from: 'от',
        to: 'до',
        extend: 'Расширить',
        apply: 'Применить',
        show_more: 'Показать больше',
        details: 'Подробнее',
        show_all: 'Показать все',
        select: 'Выбрать',
        view: 'Просмотр',
        all: 'Все',
        company: 'Компания',
        companies: 'Компании',
        in: 'в',
        account: 'Аккаунт',
        book: 'Резерв',
        respond: 'Ответить',
        open: 'Открыть',
        by: 'от',
        check_availability: 'Проверить доступность',
        reviews: 'Количество отзывов: {n}',
        view_number: 'Просмотров: {n}',
        favorites: 'Избранное',
        about: 'О нас',
        about_us: 'О нас',
        meet_the_team: 'Познакомьтесь с командой',
        our_team: 'Наша команда',
        contact_us: 'Свяжитесь с нами',
        email: 'Email',
        phone: 'Телефон',
        go_to_profile: 'Перейти в профиль',
        [true]: 'Да',
        [false]: 'Нет',
        done: 'Готово',
        description: 'Описание',
        you: 'Вы',
        invite: 'Пригласить',
        check: 'Проверить',
        date: 'Дата',
        and: 'и',
        soldout: 'РАСПРОДАНО',
        unavailable: 'НЕДОСТУПНО',
        reset: 'Сбросить',
        total_price: 'Общая стоимость:',
        total_time: 'Общее время:',
        choose_time: 'Изаберское время',
        copied: 'Скопировано',
        copy: 'Копировать',
        share: 'Делить',
        reload: 'Освежить',
        flexible: 'Гибкий',
        day: 'Eжедневный',
        month: 'Eжемесячный',
        send_sms: 'Отправить смс',
        key: 'Ключ',
        value: 'Значение',
        no_results: 'Нет результатов',
        language: 'Язык',
        view_details: 'Посмотреть подробности',
        preview_daily_schedule: 'Eжедневное расписание',
        free_reservation: 'Бесплатное бронирование',
        hours: 'Часы',
        minutes: 'Минуты',
        protected: 'защищенный',
        download_pdf: 'Скачать PDF-файл',
        note: 'Примечание',
        note_reservation: 'Примечание для бронирования',
        i_want: 'Хочу',
        dont_want: 'Не хочу',
        current_price: 'Текущая цена:',
        suggested_parking: 'Предлагаемое место для парковки',
        activate: 'Активировать',
        admin: 'Admin',
        daily: 'Ежедневно',
        weekly: 'Еженедельно',
        montly: 'Ежемесячно',
    },

    calendar: {
        today: 'Сегодня',
        slots: '1 слот | {n} слотов',
    },

    general: {
        not_saved: 'Текущие изменения не сохранены. Хотите сохранить их?',
    },

    days: {
        mon: { short: 'Пн', long: 'Понедельник' },
        tue: { short: 'Вт', long: 'Вторник' },
        wed: { short: 'Ср', long: 'Среда' },
        thu: { short: 'Чт', long: 'Четверг' },
        fri: { short: 'Пт', long: 'Пятница' },
        sat: { short: 'Сб', long: 'Суббота' },
        sun: { short: 'Вс', long: 'Воскресенье' },
    },

    months: {
        0: { short: 'Янв', long: 'Январь' },
        1: { short: 'Фев', long: 'Февраль' },
        2: { short: 'Мар', long: 'Март' },
        3: { short: 'Апр', long: 'Апрель' },
        4: { short: 'Май', long: 'Май' },
        5: { short: 'Июн', long: 'Июнь' },
        6: { short: 'Июл', long: 'Июль' },
        7: { short: 'Авг', long: 'Август' },
        8: { short: 'Сен', long: 'Сентябрь' },
        9: { short: 'Окт', long: 'Октябрь' },
        10: { short: 'Ноя', long: 'Ноябрь' },
        11: { short: 'Дек', long: 'Декабрь' },
    },

    errors: {
        common_error: 'Что-то пошло не так',
        invalid_image: 'Изображение недействительно',
        wait_for_upload_complete: 'Пожалуйста, дождитесь завершения текущей загрузки',
        location_required: 'Для создания сервиса добавьте местоположение!',
        wrong_subdomain:
            'Компания с указанным субдоменом не существует. В случае изменения субдомена попробуйте найти его в приложении Bookeraj',
    },
}
